import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface TeamMemberArtifactDto {
  id: number;
  organizationId: number;
  uploadedByUserId?: number;
  ownerUserId?: number;
  artifactType: string;
  artifactCategory: string;
  artifactScope: string;
  isEnabled: boolean;
  default?: boolean | null;
  fileName: string;
  blobPath: string;
  contentType: string;
  sizeBytes: number;
  status: string;
  dateCreated: string;
}

@Injectable({ providedIn: 'root' })
export class TeamMemberMediaService {
  private readonly http = inject(HttpClient);
  private readonly artifactsApiUrl = '/api/artifactassets';

  getFilteredMedia(organizationId?: number | null, uploadedByUserId?: number | null): Observable<TeamMemberArtifactDto[]> {
    const query = new URLSearchParams();
    if (organizationId && organizationId > 0) {
      query.set('organizationId', String(organizationId));
    }

    if (uploadedByUserId && uploadedByUserId > 0) {
      query.set('uploadedByUserId', String(uploadedByUserId));
    }

    const suffix = query.size > 0 ? `?${query.toString()}` : '';
    return this.http.get<TeamMemberArtifactDto[]>(`${this.artifactsApiUrl}${suffix}`);
  }

  getOwnMediaByOrganization(organizationId: number): Observable<TeamMemberArtifactDto[]> {
    return this.http.get<TeamMemberArtifactDto[]>(`${this.artifactsApiUrl}/organization/${organizationId}`);
  }

  getCommonMedia(): Observable<TeamMemberArtifactDto[]> {
    return this.http.get<TeamMemberArtifactDto[]>(`${this.artifactsApiUrl}/common`);
  }

  uploadCommonMedia(file: File): Observable<TeamMemberArtifactDto> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<TeamMemberArtifactDto>(`${this.artifactsApiUrl}/common/upload`, form);
  }

  deleteCommonMedia(id: number): Observable<void> {
    return this.http.delete<void>(`${this.artifactsApiUrl}/common/${id}`);
  }

  uploadMedia(organizationId: number, artifactType: 'Sound' | 'Video', artifactCategory: string, file: File): Observable<TeamMemberArtifactDto> {
    const form = new FormData();
    form.append('organizationId', String(organizationId));
    form.append('artifactType', artifactType);
    if (artifactCategory.trim()) {
      form.append('artifactCategory', artifactCategory.trim());
    }
    form.append('file', file);

    return this.http.post<TeamMemberArtifactDto>(`${this.artifactsApiUrl}/upload`, form);
  }

  replaceMedia(id: number, file: File): Observable<TeamMemberArtifactDto> {
    const form = new FormData();
    form.append('file', file);
    return this.http.put<TeamMemberArtifactDto>(`${this.artifactsApiUrl}/${id}/replace`, form);
  }

  deleteMedia(id: number): Observable<void> {
    return this.http.delete<void>(`${this.artifactsApiUrl}/${id}`);
  }

  getMediaContent(id: number): Observable<Blob> {
    return this.http.get(`${this.artifactsApiUrl}/${id}/content`, { responseType: 'blob' });
  }
}
